<template>
  <div>
    <a-button @click="showModal" class="delete-targeting-info">{{ $t('delete.targeting.info') }}</a-button>
    <delete-targeting-info-modal :visible="visible" @cancel="handleCancel" />
  </div>
</template>

<script>
import DeleteTargetingInfoModal from '@/components/account/targetingInfo/DeleteTargetingInfoModal.vue';

export default {
  components: {
    DeleteTargetingInfoModal,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';
@import '~@/assets/styles/variables';

.delete-targeting-info {
  height: 36px;
  border-radius: $border-radius;
  background-color: $red;
  color: $white;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.13px;
  line-height: 16px;
  border: none;
}
</style>
